/* ============================================================================
   ET MENU 001 — A/B variant header menu behaviour.
   Activates only when document.body has class "test-menu-001".
   - Desktop mega menu: init the active subcategory Swiper on open; swap the
     right-side products when another subcategory is hovered/focused.
   - Mobile burger drawer: open/close, background scroll lock, drill-in panels.
   ============================================================================ */
(function () {
  'use strict';

  var TEST_CLASS = 'test-menu-001';
  var booted = false;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  /* --------------------------------------------------------------------------
     MEGA MENU
     -------------------------------------------------------------------------- */
  function initSlider(panel) {
    if (!panel || panel.dataset.etDone === 'true') return;
    var el = panel.querySelector('[data-et-mm-slider]');
    if (!el) { panel.dataset.etDone = 'true'; return; }
    if (typeof Swiper === 'undefined') return; // Swiper loads deferred; retry on next open
    panel.dataset.etDone = 'true';

    new Swiper(el, {
      slidesPerView: 2.2,
      spaceBetween: 4,
      observer: true,
      observeParents: true,
      pagination: {
        el: panel.querySelector('.et-mm__pagination'),
        clickable: true
      },
      breakpoints: {
        1000: { slidesPerView: 4, spaceBetween: 4 }
      }
    });
  }

  function activateSubcategory(item, sublink) {
    var targetId = sublink.getAttribute('data-panel');

    item.querySelectorAll('[data-et-mm-sublink]').forEach(function (s) {
      s.classList.toggle('is-active', s === sublink);
    });

    var activePanel = null;
    item.querySelectorAll('.et-mm__products').forEach(function (p) {
      var on = p.getAttribute('data-panel') === targetId;
      p.classList.toggle('is-active', on);
      if (on) activePanel = p;
    });

    if (activePanel) initSlider(activePanel);
  }

  function setupMegaMenu(root) {
    root.querySelectorAll('[data-et-mm-item]').forEach(function (item) {
      // Init the default (first / active) subcategory slider when the menu opens.
      var open = function () {
        var active = item.querySelector('.et-mm__products.is-active');
        initSlider(active);
      };
      item.addEventListener('mouseenter', open);
      item.addEventListener('focusin', open);

      item.querySelectorAll('[data-et-mm-sublink]').forEach(function (sublink) {
        var swap = function () { activateSubcategory(item, sublink); };
        sublink.addEventListener('mouseenter', swap);
        sublink.addEventListener('focus', swap);
      });
    });
  }

  /* --------------------------------------------------------------------------
     DRAWER
     -------------------------------------------------------------------------- */
  function setupDrawer() {
    var drawer = document.getElementById('et-menu-001-drawer');
    if (!drawer || drawer.dataset.etDone === 'true') return;
    drawer.dataset.etDone = 'true';

    // Move the drawer to <body> so its position:fixed is relative to the
    // viewport. Inside the header it gets trapped by the sticky/transformed
    // header's containing block and is clipped to the header height.
    if (drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }

    var trigger = document.querySelector('[data-et-drawer-open]');
    var lastFocus = null;

    function showPanel(id) {
      var subs = drawer.querySelectorAll('.et-drawer__panel--sub');
      var target = null;
      subs.forEach(function (p) {
        if (p.getAttribute('data-et-drawer-panel') === id) target = p;
      });
      if (!target) return;

      target.hidden = false;
      // Force the browser to commit the off-screen start position (translateX(100%))
      // before we animate to on-screen, so the slide runs the first time too.
      void target.offsetWidth;

      subs.forEach(function (p) {
        p.classList.toggle('is-active', p === target);
      });
    }

    function resetPanels() {
      drawer.querySelectorAll('.et-drawer__panel--sub').forEach(function (p) {
        p.classList.remove('is-active');
      });
    }

    function openDrawer() {
      lastFocus = document.activeElement;
      drawer.hidden = false;
      // force reflow so the transition runs from the hidden state
      void drawer.offsetWidth;
      drawer.classList.add('is-open');
      document.body.classList.add('et-drawer-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      var closeBtn = drawer.querySelector('[data-et-drawer-close]');
      if (closeBtn) closeBtn.focus();
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      document.body.classList.remove('et-drawer-open');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      var onEnd = function () {
        drawer.hidden = true;
        resetPanels();
        drawer.removeEventListener('transitionend', onEnd);
      };
      drawer.addEventListener('transitionend', onEnd);
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    if (trigger) trigger.addEventListener('click', openDrawer);

    drawer.addEventListener('click', function (e) {
      var toBtn = e.target.closest('[data-et-drawer-to]');
      if (toBtn) { showPanel(toBtn.getAttribute('data-et-drawer-to')); return; }

      if (e.target.closest('[data-et-drawer-back]')) { resetPanels(); return; }

      if (e.target.closest('[data-et-drawer-close]') || e.target.classList.contains('et-drawer__overlay')) {
        closeDrawer();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });
  }

  /* --------------------------------------------------------------------------
     BOOT
     -------------------------------------------------------------------------- */
  function boot() {
    if (booted) return;
    if (!document.body.classList.contains(TEST_CLASS)) return;
    booted = true;

    document.querySelectorAll('.et-mm').forEach(setupMegaMenu);
    setupDrawer();

    // Re-init in the theme editor when the header section reloads.
    document.addEventListener('shopify:section:load', function () {
      document.querySelectorAll('.et-mm').forEach(function (root) {
        root.querySelectorAll('.et-mm__products').forEach(function (p) { p.dataset.etDone = ''; });
        setupMegaMenu(root);
      });
      var drawer = document.getElementById('et-menu-001-drawer');
      if (drawer) drawer.dataset.etDone = '';
      setupDrawer();
    });
  }

  function watchBodyClass() {
    if (document.body.classList.contains(TEST_CLASS)) { boot(); return; }
    var observer = new MutationObserver(function () {
      if (document.body.classList.contains(TEST_CLASS)) {
        observer.disconnect();
        boot();
      }
    });
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  ready(watchBodyClass);
})();
